import React from "react";

// The address is rendered as two adjacent nodes so the prerendered HTML never
// holds one contiguous address string for text scrapers, while people and
// screen readers still read it correctly. It stays whole in JSON-LD and in the
// mailto:/compose links on purpose: Google and AI crawlers need a readable
// business contact to keep the LocalBusiness trust signal.
const USER = "info";
const DOMAIN = "gslimoelite.com";

export const EMAIL_ADDRESS = `${USER}@${DOMAIN}`;
export const GMAIL_COMPOSE_URL = `https://mail.google.com/mail/?view=cm&fs=1&to=${EMAIL_ADDRESS}`;

export default function EmailAddress(): JSX.Element {
  return (
    <>
      <span>{USER}</span>
      <span>{`@${DOMAIN}`}</span>
    </>
  );
}
